{
  "headings": {
    "feedback": "Anna palautetta",
    "givenFeedback": "Annettu palaute",
    "feedbackPreview": "Palautteen esikatselu",
    "feedbackDetail": "Palautteen tiedot",
    "preview": "Esikatselu",
    "success": "Palaute"
  },
  "texts": {
    "instructions": "Osallistu kehittämiseen, jaa ideasi!\n\nHaluamme kehittää toimintaamme ja näkemyksesi on meille tärkeä. Jaa kokemuksesi, ideasi tai kehitysehdotuksesi tällä lomakkeella.",
    "success": "Palaute on lähetetty. Kiitos palautteestasi!",
    "expectsResponseInstructions": "Haluatko vastauksen palautteeseesi? Jos toivot saavasi vastauksen, mainitsethan siitä viestissäsi. Näin voimme varmistaa, että palaamme asiaan mahdollisimman sujuvasti.",
    "contactDetailsUpdateInstructions": "Voit tarvittaessa päivittää yhteystietosi tässä. Voit muokata niitä myös Omat tiedot -sivun kautta."
  },
  "placeholders": {
    "title": "Otsikko",
    "description": "Kerro tarkemmin, mitä palaute koskee"
  },
  "alt": {
    "successIllustration": "Kiitos kuvitus"
  },
  "labels": {
    "title": "Otsikko",
    "description": "Kuvaus",
    "files": "Liitteet",
    "email": "Sähköposti",
    "phoneNumber": "Puhelin",
    "expectsResponse": "Haluan, että minuun otetaan yhteyttä"
  },
  "actions": {
    "back": "Takaisin",
    "resetForm": "Tyhjennä lomake",
    "sendForm": "Lähetä palaute",
    "preview": "Esikatsele",
    "edit": "Muokkaa",
    "submit": "Lähetä"
  },
  "errors": {
    "submitError": "Virhe palautteen lähetyksessä. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.",
    "serviceUnavailable": "Palautteen luonti ei juuri nyt onnistu. Ole hyvä ja yritä myöhemmin uudelleen.",
    "noFeedbackFound": "Palautetta ei löytynyt.",
    "missingUserPhoneNumber": {
      "title": "Palautteen luonti ei valitettavasti onnistu",
      "message": "Jatkaaksesi palautteen tekemistä, lisää puhelinnumerosi profiiliisi."
    }
  }
}
